import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  useTheme,
} from "@mui/material";
import { YantraExecution } from "../../tanstack/queries/player";
import { useTranslate } from "../../hooks/useTranslate";
import { useIntl } from "react-intl";

interface IExecutionCardProps {
  execution: YantraExecution;
  onSelectExecution: () => void;
}

export default function ExecutionCard({
  execution,
  onSelectExecution,
}: IExecutionCardProps) {
  const { t } = useTranslate();
  const theme = useTheme();
  const { formatNumber } = useIntl();
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: { xs: 1.5, xl: 2.5 },
        py: { xs: 1, xl: 1.5 },
        borderRadius: theme.spacing(3),
        width: theme.spacing(20),
        position: "relative",
        zIndex: 2,
        cursor: "pointer",
        transition: "all .3s",
      }}
      onClick={onSelectExecution}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          width: "100%",
          height: "100%",
        }}
      />
      <CardMedia
        sx={{
          width: "100%",
          aspectRatio: "1",
          objectFit: "cover",
          borderRadius: theme.spacing(3),
        }}
        component={"img"}
        image={`${execution.image}`}
        title={execution.name}
      />
      <CardContent
        sx={{
          width: "100%",
          p: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: {
              xs: theme.typography.pxToRem(12),
              md: theme.typography.pxToRem(20),
            },
          }}
        >
          {execution.name}
        </Typography>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: {
              xs: theme.typography.pxToRem(12),
              md: theme.typography.pxToRem(14),
            },
          }}
        >
          {t("executions.price", {
            price: formatNumber(execution.price, { minimumFractionDigits: 2 }),
            rowPrice: formatNumber(execution.rowPrice, {
              minimumFractionDigits: 2,
            }),
          })}
        </Typography>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: {
              xs: theme.typography.pxToRem(12),
              md: theme.typography.pxToRem(14),
            },
          }}
        >
          {t("executions.payout", {
            payout: formatNumber(execution.payout, {
              minimumFractionDigits: 2,
            }),
            rowPayout: formatNumber(execution.rowPayout, {
              minimumFractionDigits: 2,
            }),
          })}
        </Typography>
      </CardContent>
    </Card>
  );
}
